/**
 * True when Clerk rejects a `strategy` (e.g. `email_link` not enabled for that flow).
 * Clerk often puts the sentence in `longMessage`, not `message`, so we scan all fields.
 */
export function isClerkStrategyNotAllowedError(err: unknown): boolean {
  const parts: string[] = [];
  const e = err as {
    message?: string;
    errors?: Array<{ message?: string; longMessage?: string; code?: string }>;
  };
  if (typeof e?.message === 'string') parts.push(e.message);
  for (const item of e.errors ?? []) {
    if (item?.message) parts.push(item.message);
    if (item?.longMessage) parts.push(item.longMessage);
    if (item?.code) parts.push(item.code);
  }
  try {
    parts.push(JSON.stringify(err));
  } catch {
    /* ignore */
  }

  const text = parts.join(' ').toLowerCase();
  const mentionsLink = text.includes('email_link');
  const mentionsStrategyReject =
    text.includes('allowed values') ||
    text.includes('form_param_value_invalid') ||
    text.includes('invalid_strategy');

  return (
    mentionsStrategyReject &&
    (mentionsLink || text.includes('strategy') || text.includes('parameter'))
  );
}
